import { nextFrame } from "../../../library-js/animation/nextFrame";
import { Events, OnClick } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { ClassConstructor, Func, Func2, isFunction } from "../../../library-js/tools/TypeUtilities";
import { InspectorContainer } from "../containers/InspectorContainer";
import { ContainerField } from "../fields/ContainerField";
import { Inspector } from "../Inspector";
import { InspectorCreationInfo } from "../InspectorCreationInfo";
import { InspectorNameTransformer } from "../InspectorNameTransformer";

export class List<T>
{
  _class:ClassConstructor;
  _data:T[] = [];

  constructor( cls:ClassConstructor )
  {
    this._class = cls;  
  }

  get data():T[]
  {
    return this._data;
  }

  forEach( cb:(t:T,i?:number)=>void )
  {
    for ( let i = 0; i < this._data.length; i++ )
    {
      cb( this._data[ i ], i );
    }
  }

  fill( creator:Func<T>, times:number = 1)
  {
    for ( let i = 0; i < times; i++ )
    {
      this._data.push( creator() );
    }

    return this;
  }

  get size(){ return this._data.length; }

  get( index:number )
  {
    return this._data[ index ];
  }

  clear()
  {
    this._data = [];
  }

  set( index:number, t:T )
  {
    this._data[ index ] = t;
  }

  add( t:T )
  {
    this._data.push( t );
  }

  addNew()
  {
    this._data.push( new ( this._class as any )() );
  }

  static createInspectorField( parentInfo:InspectorCreationInfo, info:InspectorCreationInfo, parent:Element )
  {
    let list = info.object as List<any>;

    let containerField = new ContainerField();
    let childContainer = info.creator.addField( parentInfo, info, containerField, parent ); 
    
    let nameElement = InspectorContainer.containerName.query( containerField.container );

    HTMLEditor.setText( nameElement, InspectorNameTransformer.convert( containerField.memberName ) + ` (${list.size})` );

    for ( let i = 0; i < list.size; i++ )
    {      
      let entryInfo = info.listEntry( i, containerField );
      info.creator.createField( info, entryInfo, childContainer );
    }

    let adder = containerField.addAdder() as HTMLElement;
    let adderBlock = ContainerField.adderBlock.getParent( adder );

    OnClick.add( adder, 
      ()=>
      { 

        let index = list.size;
        list.addNew();
        let entryInfo = info.listEntry( index, containerField );
        info.creator.createField( info, entryInfo, childContainer );


        HTMLEditor.setAsLastChild( adderBlock );
        HTMLEditor.setText( nameElement, InspectorNameTransformer.convert( containerField.memberName ) + ` (${list.size})` );

      }
    );
 
    Events.disableSelection( adder as HTMLElement );

  }
  
}